// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  DefaultForm,
  DefaultFormGlobalValidation,
  DefaultFormSubmit,
  DefaultFormText,
  DefaultFormFile, DefaultFormDropDown,
} from '../../elements/DefaultForm';

import type { Device } from '../model/Device.model';
import { deviceMetaModel } from '../model/Device.model';
import Loader from '../../elements/Loader';
import LoadFailed from '../../elements/LoadFailed';
import ErrorCapsule from '../../core/exceptions/ErrorCapsule';
import type { DeviceType } from '../model/DeviceType.model';
import { announceFileIsUploaded } from '../../core/render/visualUtils';

export type DeviceEditPageViewProps = {
  device: null | Device | ErrorCapsule,
  deviceTypes: null | Array<DeviceType> | ErrorCapsule,
  onSubmit: (values: { [string]: any }) => void,
}

export default function DeviceEditPageView({
  device,
  deviceTypes,
  onSubmit,
}: DeviceEditPageViewProps) {
  const { t } = useTranslation();

  if (device instanceof ErrorCapsule) return <LoadFailed error={device} />;
  if (deviceTypes instanceof ErrorCapsule) return <LoadFailed error={deviceTypes} />;
  if (!device || !deviceTypes) return <Loader />;

  const isCreating = device.id == null;
  const pageTitle = isCreating
    ? 'Добавление модели'
    : `Редактирование ${device.name}`;

  return (
    <div className="device-edit">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/library/brands/">Бренды</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to={`/library/devices/${device.brand.id}/`}>{device.brand.name}</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">{pageTitle}</li>
        </ol>
      </nav>
      <h1>{pageTitle}</h1>

      <DefaultForm
        form="deviceEdit"
        metaModel={deviceMetaModel}
        initialValues={device}
        onSubmit={values => onSubmit(values)}
      >
        <DefaultFormGlobalValidation />
        <DefaultFormText attribute="name" autoFocus />
        <DefaultFormDropDown
          attribute="deviceTypeId"
          options={deviceTypes.map(({ id, name }) => [id, name])}
        />
        <DefaultFormFile attribute="preview" hint={announceFileIsUploaded(device.preview)} />
        <DefaultFormSubmit label={isCreating ? 'Добавить' : 'Изменить'} />
      </DefaultForm>
    </div>
  );
}
